import { render } from "./index.vue?vue&type=template&id=1908674b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=1908674b&scoped=true&lang=css"

import exportComponent from "/Users/a2019/Documents/Project/MiniApp/miniapp_wing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1908674b"]])

export default __exports__